import getCookie from '../utils/cookies';
import isBrowser from '../utils/isBrowser';

export const useCookie = (
  name: string
): string | undefined => {
  const cookie = isBrowser() ? getCookie(name) : undefined;

  return cookie;
};

export default useCookie;
